import { Typography } from "@mui/material";
import { ActionButton, IconAddOutlined, IconCustomerDetailEmail, IconCustomerDetailPhone } from "design-components";
import type { OperatorDetail } from "../types";

export interface OperatorDetailOverviewProps {
  operator: OperatorDetail;
}

export function OperatorDetailOverview({ operator }: OperatorDetailOverviewProps) {
  return (
    <div className="customer-detail-overview operator-detail-overview">
      <div className="customer-detail-overview__columns">
        <div className="customer-detail-overview__logo-column">
          <div className="customer-detail-overview__logo-card">
            <div className="customer-detail-overview__logo-frame operator-detail-overview__logo-frame">
              <div className="operator-detail-overview__brand-mark" aria-hidden>
                <div className="operator-detail-overview__brand-mark-top" />
                <div className="operator-detail-overview__brand-mark-bottom" />
              </div>
              <Typography component="p" className="operator-detail-overview__brand-name">
                {operator.companyName.replace(" ", "")}
              </Typography>
            </div>
          </div>
          <button type="button" className="operator-detail-overview__logo-edit-link">
            Edit logo
          </button>
        </div>

        <div className="customer-detail-card customer-detail-overview__details-panel">
          <Typography
            component="h2"
            className="customer-detail-overview__section-title customer-detail-overview__section-title--details"
          >
            Operator details
          </Typography>

          <div className="customer-detail-overview__details-fields carrier-detail-overview__details-fields">
            <div className="carrier-detail-overview__read-row">
              <Typography component="p" className="carrier-detail-overview__read-label">
                Company legal name
              </Typography>
              <Typography component="p" className="carrier-detail-overview__read-value">
                {operator.companyLegalName}
              </Typography>
            </div>

            <div className="carrier-detail-overview__read-row">
              <Typography component="p" className="carrier-detail-overview__read-label">
                Primary contact
              </Typography>
              <Typography component="p" className="carrier-detail-overview__read-value">
                {operator.primaryContact}
              </Typography>
            </div>

            <div className="customer-detail-overview__details-fields">
              <div className="carrier-detail-overview__read-row">
                <Typography component="p" className="carrier-detail-overview__read-label">
                  Phone
                </Typography>
                <div className="carrier-detail-overview__contact-row">
                  <IconCustomerDetailPhone className="carrier-detail-overview__contact-icon" aria-hidden size={24} />
                  <Typography component="a" className="carrier-detail-overview__contact-link" href={`tel:${operator.phone}`}>
                    {operator.phone}
                  </Typography>
                </div>
              </div>

              <div className="carrier-detail-overview__read-row">
                <Typography component="p" className="carrier-detail-overview__read-label">
                  Email
                </Typography>
                <div className="carrier-detail-overview__contact-row">
                  <IconCustomerDetailEmail className="carrier-detail-overview__contact-icon" aria-hidden size={24} />
                  <Typography
                    component="a"
                    className="carrier-detail-overview__contact-link"
                    href={`mailto:${operator.email}`}
                  >
                    {operator.email}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="customer-detail-overview__card">
          <div className="customer-detail-overview__card-inner">
            <Typography
              component="h2"
              className="customer-detail-overview__section-title customer-detail-overview__section-title--users"
            >
              Users
            </Typography>

            <div className="customer-detail-overview__users-body">
              <div className="customer-detail-overview__user-list">
                {operator.users.map((user) => (
                  <div key={user.id} className="customer-detail-overview__user-row">
                    <Typography
                      component="p"
                      className="customer-detail-overview__user-cell customer-detail-overview__user-cell--name"
                    >
                      {user.fullName}
                    </Typography>
                    <Typography
                      component="p"
                      className="customer-detail-overview__user-cell customer-detail-overview__user-cell--role"
                    >
                      {user.role}
                    </Typography>
                    <Typography
                      component="p"
                      className="customer-detail-overview__user-cell customer-detail-overview__user-cell--meta"
                    >
                      {user.lastSeenLabel}
                    </Typography>
                  </div>
                ))}
              </div>

              <div className="customer-detail-overview__add-row">
                <ActionButton
                  actionVariant="neutral"
                  size="small"
                  className="customer-detail-overview__add-btn"
                  startIcon={<IconAddOutlined aria-hidden size={20} />}
                >
                  Add
                </ActionButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
